import EventSchedule16 from '@carbon/icons-react/es/event--schedule/16';
import moment from 'moment';
import React, { FC } from 'react';
import styled from 'styled-components';
import { ContentToRender } from 'components/atoms/due-date-picker/trigger';
import { CellRendererParams } from './types';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-02);
  svg {
    flex-shrink: 0;
  }
`;

export const DueDateRenderer: FC<CellRendererParams> = ({ data }) => (
  <Wrapper>
    <EventSchedule16 />
    <ContentToRender
      startDate={data.startDate != null ? moment(data.startDate) : null}
      dueDate={data.dueDate != null ? moment(data.dueDate) : null}
      placeholder={false}
    />
  </Wrapper>
);
